import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { IAddAddressResponse, ITeleconsultation } from "@/api_framework/api_modals/Users";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

import { useAPIUtils } from "../../useAPIUtils";
AxiosCurlirize(axios, () => {});
// returns new created addressID
export const useTeleconsultationAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async (formData: ITeleconsultation): Promise<string | null> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
      const requestHeaders = new Headers();
      requestHeaders.append("Authorization", `${accessToken}`);
      const response: string = await axios
        .post(CUSTOMER_APIS?.TELECONSULTATION?.baseURL ?? "", formData, {
          headers: { Authorization: requestHeaders.get("Authorization") },
        })
        .then((res: AxiosResponse<IAddAddressResponse>) => {
          if (res.data.status === true) {
            toast.success(`Call initiated`);
          } else {
            return null;
          }
        })
        .catch((e: AxiosError) => {
          captureError(e);
          sendCurl(e.config["curlCommand"]);

          return null;
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error. Please contact central team!");
      return null;
    }
    return null;
  }, []);
  return { execute };
};
